import * as React from "react";
import * as ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import { BrowserRouter } from "react-router-dom";
import { Layout } from "./layout/Layout";
import "./index.css";

//import registerServiceWorker from './registerServiceWorker';
import unregister from "./registerServiceWorker";

let routes = <Layout/>;

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href")!;
ReactDOM.render(
    <AppContainer>
        <BrowserRouter children={routes} basename={baseUrl} />
    </AppContainer>,
    document.getElementById("root") as HTMLElement
);
//registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.tsx